module.exports = __webpack_public_path__ + "static/media/Productos.1f80d97b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Section-servicios/Images/Productos.svg
// module id = 131
// module chunks = 0